import React from "react";
import ContentLoader from "react-content-loader";

const LoaderAdminUsers = (props) => (
  <ContentLoader
    viewBox="0 0 1100 520"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    {/* Header left (title + subtitle) */}
    <rect x="0" y="6" rx="6" ry="6" width="240" height="16" />
    <rect x="0" y="28" rx="6" ry="6" width="160" height="12" />

    {/* Header right button */}
    <rect x="930" y="8" rx="18" ry="18" width="160" height="30" />

    {/* Filters: search */}
    <rect x="0" y="60" rx="18" ry="18" width="460" height="34" />

    {/* Filters: selects */}
    <rect x="480" y="60" rx="10" ry="10" width="180" height="34" />
    <rect x="670" y="60" rx="10" ry="10" width="180" height="34" />
    <rect x="860" y="60" rx="10" ry="10" width="230" height="34" />

    {/* Table header bar */}
    <rect x="0" y="110" rx="10" ry="10" width="1090" height="42" />

    {/* Rows skeleton (6 rows) */}
    {Array.from({ length: 6 }).map((_, i) => {
      const y = 170 + i * 55;

      return (
        <React.Fragment key={i}>
          {/* avatar */}
          <circle cx="22" cy={y + 10} r="16" />

          {/* name + id */}
          <rect x="52" y={y - 2} rx="6" ry="6" width="220" height="12" />
          <rect x="52" y={y + 16} rx="6" ry="6" width="180" height="10" />

          {/* email */}
          <rect x="300" y={y - 2} rx="6" ry="6" width="230" height="12" />
          {/* tel */}
          <rect x="540" y={y - 2} rx="6" ry="6" width="130" height="12" />
          {/* ville */}
          <rect x="680" y={y - 2} rx="6" ry="6" width="120" height="12" />

          {/* role badge */}
          <rect x="810" y={y - 6} rx="14" ry="14" width="90" height="22" />
          {/* status badge */}
          <rect x="910" y={y - 6} rx="14" ry="14" width="80" height="22" />

          {/* actions */}
          <rect x="1000" y={y - 10} rx="10" ry="10" width="34" height="34" />
          <rect x="1045" y={y - 10} rx="10" ry="10" width="34" height="34" />

          {/* row divider */}
          <rect x="0" y={y + 34} rx="0" ry="0" width="1090" height="1" />
        </React.Fragment>
      );
    })}

    {/* Pagination */}
    <rect x="470" y="500" rx="12" ry="12" width="40" height="36" />
    <rect x="520" y="508" rx="6" ry="6" width="160" height="18" />
    <rect x="690" y="500" rx="12" ry="12" width="40" height="36" />
  </ContentLoader>
);

LoaderAdminUsers.metadata = {
  name: "Chargement",
  github: "Deal",
  description: "chargement de la gestion des utilisateurs",
  filename: "LoaderAdminUsers.jsx",
};

export default LoaderAdminUsers;
